<template>
  <b-card
    v-if="data"
    class="card-tiny-line-stats h-100"
    body-class="pb-50"
  >
    <b-card-header class="p-0">
      <b-card-title>
        <h6>
          Tambah produk registry pertama kali
        </h6>
      </b-card-title>
      <b-dropdown
        no-caret
        right
        :text="filterActive.title"
        variant="transparent"
        class="chart-dropdown"
        toggle-class="p-50"
        size="sm"
      >
        <b-dropdown-item
          v-for="(item, index) in filterList"
          :key="`list-filter-${index}`"
          @click="fetchData(item)"
        >
          {{ item.title }}
        </b-dropdown-item>
      </b-dropdown>
    </b-card-header>
    <!-- chart -->
    <b-card-body class="p-0">
      <vue-apex-charts
        v-if="!isLoading"
        :options="chartOptions"
        :height="chartHeight"
        :series="chartDatas"
      />

      <div
        v-else
        class="text-center"
      >
        <b-spinner
          variant="primary"
          label="Spinning"
          class="mt-2"
        />
      </div>
    </b-card-body>
  </b-card>
</template>

<script>
import { mapActions } from 'vuex'
import {
  BCard,
  BCardHeader,
  BCardTitle,
  BCardBody,
  BSpinner,
  BDropdown,
  BDropdownItem,
} from 'bootstrap-vue'
import VueApexCharts from 'vue-apexcharts'
import { $themeColors } from '@themeConfig'

export default {
  components: {
    BCard,
    BCardHeader,
    BCardTitle,
    BCardBody,
    VueApexCharts,
    BSpinner,
    BDropdown,
    BDropdownItem,
  },
  props: {
    data: {
      type: Array,
      default: () => [],
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
    chartHeight: {
      type: [Number, String],
      default: 200,
    },
  },
  data() {
    return {
      filterActive: {
        title: '1 bulan terakhir',
        value: 'month',
      },
      filterList: [
        {
          title: '7 hari terakhir',
          value: 'week',
        },
        {
          title: '1 bulan terakhir',
          value: 'month',
        },
        {
          title: '1 tahun terakhir',
          value: 'year',
        },
      ],
      chartOption: {
        chart: {
          toolbar: {
            show: false,
          },
          type: 'line',
        },
        dataLabels: {
          enabled: false,
        },
        stroke: {
          curve: 'smooth',
          width: 3,
        },
        fill: {
          type: 'solid',
          opacity: [0.35],
        },
        legend: {
          show: true,
          position: 'bottom',
          horizontalAlign: 'center',
          fontSize: '14px',
          fontFamily: 'Montserrat',
        },
        colors: [$themeColors.info],
        grid: {
          xaxis: {
            lines: {
              show: false,
            },
          },
        },
        xaxis: {
          labels: {
            show: true,
          },
          axisBorder: {
            show: false,
          },
          axisTicks: {
            show: false,
          },
        },
        yaxis: [{
          show: true,
        }],
      },
    }
  },
  computed: {
    chartDatas() {
      if (this.data && this.data.length > 0) {
        return this.data.map(series => ({
          name: series.name || 'Tambah Produk Pertama',
          type: 'area',
          data: series.data,
        }))
      }
      return []
    },
    chartOptions() {
      return {
        ...this.chartOption,
        tooltip: {
          shared: true,
          x: {
            formatter: val => {
              // Apabila x bukan numeric timestamp yang valid, cobalah untuk dikembalikan format aslinya
              if (!val) return val
              const date = new Date(val)

              if (Number.isNaN(date.getTime())) return val

              const options = this.isMonthly
                ? { year: 'numeric', month: 'long' }
                : { day: 'numeric', month: 'short', year: 'numeric' }

              return new Intl.DateTimeFormat('id-ID', options).format(date)
            },
          },
        },
        xaxis: {
          ...this.chartOption.xaxis,
          type: 'datetime',
        },
      }
    },
    isMonthly() {
      if (!this.data || this.data.length < 1 || !this.data[0].data || this.data[0].data.length < 2) return false

      const firstEl = this.data[0].data[0]
      const secondEl = this.data[0].data[1]

      const first = new Date(firstEl.x || firstEl.date || firstEl[0])
      const second = new Date(secondEl.x || secondEl.date || secondEl[0])

      if (Number.isNaN(first.getTime()) || Number.isNaN(second.getTime())) return false

      const diffTime = Math.abs(second - first)
      const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24))

      return diffDays > 20
    },
  },
  methods: {
    ...mapActions('dashboard', ['getFirstProductRegistry']),
    fetchData(item) {
      this.filterActive = item
      this.getFirstProductRegistry({ interval: item.value })
    },
  },
}
</script>
